import { all, call, put, takeLatest } from "redux-saga/effects";
import { AxiosPost } from "../../../utils/axios";
import * as actions from "./actions";


function* fetchMushroomsByCountry(action) {
    try {
        const result = yield call(AxiosPost, `/resources/get_mushroom_by_country/`, action.payload);
        yield put(actions.fetchMushroomByCountrySuccess(result.data))
    } catch (e) {
        yield put(actions.fetchMushroomByCountryFailure(e))
    }
}


export default function* rootSaga() {
    yield all([
        // Watchers Articles
        takeLatest(actions.FETCH_MUSHROOM_BY_COUNTRY.REQUEST, fetchMushroomsByCountry),
    ])
}

